module.exports = __webpack_public_path__ + "static/img/pca_face.32168b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prj/pca_face.jpg
// module id = Kql5
// module chunks = 1